import React from 'react'
import { Heading } from '@myxplor/ui'

// This is incase there is no SuccessComponent supplied with the report
export const ReportDefaultSuccessMessage = ({ name }) => (
  <fieldset>
    <Heading small>{name} is being generated now</Heading>
    It can take several minutes to generate the report, so we will email you once the report has
    been generated. Then you can download the report to you own computer
  </fieldset>
)



// WEBPACK FOOTER //
// ./src/provider-level/reports/views/default-success.jsx